import { Brands } from '@framework/brands';
import { getBrandedEnvironmentConfig, getEnvVariableStrict } from '../configHelper.js';
const DEV_DOMAIN = 'redirector.bf-cpx-development.aws.bfops.io';
const BESTCHECK_DOMAIN = 'x.bestcheck.de';
const production = {
    [Brands.BUNTE]: { domain: 'x.bunte.de' },
    [Brands.CHIP]: { domain: 'x.chip.de' },
    [Brands.FINANZEN100]: { domain: 'x.finanzen100.de' },
    [Brands.FITFORFUN]: { domain: 'x.fitforfun.de' },
    [Brands.FOCUS]: { domain: 'x.focus.de' },
    [Brands.MITTIER]: { domain: 'x.mit-tier.de' },
    [Brands.MITSTERNEN]: { domain: 'x.mit-sternen.de' },
    [Brands.MITBEZIEHUNG]: { domain: 'x.mit-beziehung.de' },
    [Brands.TVTODAY]: { domain: 'x.tvtoday.de' },
    [Brands.TVSPIELFILM]: { domain: 'x.tvspielfilm.de' },
};
const development = Object.keys(production).reduce((acc, x) => ({ ...acc, [x]: { domain: DEV_DOMAIN } }), production);
const definition = {
    base: {
        _: { domain: '' },
        ...development,
    },
    // We need to use prod for local because of it helps catch bugs earlier.
    // The client side have to use local, but the server side obviously uses prod env (on the prod).
    local: production,
    local_k8s: production,
    production,
};
export const CPXDomains = Object.freeze(new Set(Object.values(production)
    .map((x) => x.domain)
    .concat([DEV_DOMAIN, BESTCHECK_DOMAIN])));
export const CPXTrackingConfig = (brand) => getBrandedEnvironmentConfig(definition, brand);
export const cpxEnvConfig = () => {
    return {
        signingKey: getEnvVariableStrict('CPX_SIGNING_KEY'),
    };
};
//# sourceMappingURL=cpx-tracking.config.js.map